import { useCallback, useState } from "react";
import { RenderMode } from "pytha";
import { CAMERA_TYPE } from "@/routes/tab-routes/draw/viewport";
export interface SystemStatus {

    updateDrawPanel: boolean
    setUpdateDrawPanel: (value: boolean) => void

    currentRenderMode: number
    setCurrentRenderMode: (value: number) => void

    currentCameraType: number
    setCurrentCameraType: (value: number) => void

    showMonitorObjectEntities: boolean // 是否展示监测对象图元
    setShowMonitorObjectEntities: (value: boolean) => void // 设置是否展示监测对象图元的状态

    needRenderTab: () => void

    warningCount: number
    setWarningCount: (value: number) => void

}

export function useSystemService() {

    const [updateDrawPanel, setUpdateDrawPanel] = useState<boolean>(); // 重新初始化绘图区
    const [currentRenderMode, setCurrentRenderMode] = useState<number>(RenderMode.WIREFRAME); // 当前渲染类型（0-线框 1-概念）

    const [currentCameraType, setCurrentCameraType] = useState<number>(CAMERA_TYPE.Orthographic);  //当前相机类型

    const [renderTabFlag, setRenderTabFlag] = useState<boolean>(false);  //重新渲染tab-route

    const [showMonitorObjectEntities, setShowMonitorObjectEntities] = useState<boolean>(false);  // 是否展示监测对象图元

    const [warningCount, setWarningCount] = useState<number>(0);  // 当前项目报警条数

    const needRenderTab = useCallback(() => {
        setRenderTabFlag(pre => !pre);
    }, [renderTabFlag])

    return {
        updateDrawPanel, setUpdateDrawPanel,
        currentRenderMode, setCurrentRenderMode,
        currentCameraType, setCurrentCameraType,
        showMonitorObjectEntities, setShowMonitorObjectEntities,
        needRenderTab,
        warningCount, setWarningCount,
        // projectIds, setProjectIds,
    } as SystemStatus
}

